export default class Particle {
  constructor (opts, screen) {
    this.points = [[-40.107,25],[-38.428,27.783],[-36.885,25],[-33.662,25],[-32.1,27.783],[-33.662,30.547],[-30.439,30.547],[-28.877,33.33],[-27.217,30.547],[-24.102,30.547],[-25.664,27.783],[-24.102,25],[-20.889,25],[-19.209,27.783],[-17.666,25],[-14.434,25],[-12.773,27.783],[-14.434,30.547],[-11.211,30.547],[-9.658,33.33],[-11.211,36.113],[-14.434,36.113],[-12.773,38.887],[-14.434,41.67],[-11.211,41.67],[-9.658,44.443],[-7.998,41.67],[-4.766,41.67],[-3.213,44.443],[-4.766,47.227],[-1.553,47.227],[0.01,50],[1.553,47.227],[4.785,47.227],[3.232,44.443],[4.785,41.67],[8.008,41.67],[9.678,44.443],[11.221,41.67],[14.443,41.67],[12.783,38.887],[14.443,36.113],[11.221,36.113],[9.678,33.33],[11.221,30.547],[14.443,30.547],[12.783,27.783],[14.443,25],[17.676,25],[19.229,27.783],[20.898,25],[24.111,25],[25.674,27.783],[24.111,30.547],[27.227,30.547],[28.896,33.33],[30.449,30.547],[33.662,30.547],[32.119,27.783],[33.662,25],[36.895,25],[38.457,27.783],[40.117,25],[43.33,25],[41.67,22.227],[43.33,19.443],[40.117,19.443],[38.457,16.67],[40.117,13.887],[43.33,13.887],[41.67,11.113],[43.33,8.33],[40.117,8.33],[38.457,5.547],[36.895,8.33],[33.662,8.33],[32.119,5.547],[33.662,2.783],[30.449,2.783],[28.896,0],[30.449,-2.773],[33.662,-2.773],[32.119,-5.547],[33.662,-8.34],[36.895,-8.34],[38.457,-5.547],[40.117,-8.34],[43.33,-8.34],[41.67,-11.113],[43.33,-13.887],[40.117,-13.887],[38.457,-16.67],[40.117,-19.434],[43.33,-19.434],[41.67,-22.217],[43.33,-25],[40.117,-25],[38.457,-27.773],[36.895,-25],[33.662,-25],[32.119,-27.773],[33.662,-30.557],[30.449,-30.557],[28.896,-33.34],[27.227,-30.557],[24.111,-30.557],[25.674,-27.773],[24.111,-25],[20.898,-25],[19.229,-27.773],[17.676,-25],[14.443,-25],[12.783,-27.773],[14.443,-30.557],[11.221,-30.557],[9.678,-33.34],[11.221,-36.113],[14.443,-36.113],[12.783,-38.887],[14.443,-41.67],[11.221,-41.67],[9.678,-44.434],[8.008,-41.67],[4.785,-41.67],[3.232,-44.434],[4.785,-47.217],[1.553,-47.217],[0.01,-50],[-1.553,-47.217],[-4.766,-47.217],[-3.213,-44.434],[-4.766,-41.67],[-7.998,-41.67],[-9.658,-44.434],[-11.211,-41.67],[-14.434,-41.67],[-12.773,-38.887],[-14.434,-36.113],[-11.211,-36.113],[-9.658,-33.34],[-11.211,-30.557],[-14.434,-30.557],[-12.773,-27.773],[-14.434,-25],[-17.666,-25],[-19.209,-27.773],[-20.889,-25],[-24.102,-25],[-25.664,-27.773],[-24.102,-30.557],[-27.217,-30.557],[-28.877,-33.34],[-30.439,-30.557],[-33.662,-30.557],[-32.1,-27.773],[-33.662,-25],[-36.885,-25],[-38.428,-27.773],[-40.107,-25],[-43.33,-25],[-41.67,-22.217],[-43.33,-19.434],[-40.107,-19.434],[-38.428,-16.67],[-40.107,-13.887],[-43.33,-13.887],[-41.67,-11.113],[-43.33,-8.34],[-40.107,-8.34],[-38.428,-5.547],[-36.885,-8.34],[-33.662,-8.34],[-32.1,-5.547],[-33.662,-2.773],[-30.439,-2.773],[-28.877,0],[-30.439,2.783],[-33.662,2.783],[-32.1,5.547],[-33.662,8.33],[-36.885,8.33],[-38.428,5.547],[-40.107,8.33],[-43.33,8.33],[-41.67,11.113],[-43.33,13.887],[-40.107,13.887],[-38.428,16.67],[-40.107,19.443],[-43.33,19.443],[-41.67,22.227],[-43.33,25]]
    this.options = opts
    this.spin = false
    this.rotation = 0
    this.speedModifier = 1
    this.setBoundaries(screen)
    this.setFixed()
    this.setPoints(screen, true)
    this.setRandoms(screen, true)
    this.setDirection(screen)
  }

  reset (screen, fromStart) {
    this.setPoints(screen, true)
    if (fromStart) {
      this.position = {
        x: this.origin.x,
        y: this.origin.y
      }
    } else {
      this.position = {
        x: this.endPoint.x,
        y: this.endPoint.y
      }
    }
    this.setRandoms(screen)
    this.setDirection(screen)
  }

  setBoundaries (screen) {
    this.boundaries = [
      -screen.w * 0.1,
      -screen.h * 0.1,
      screen.w * 1.1,
      screen.h * 1.1
    ]
  }

  setFixed () {
    this.side = Math.floor(Math.random() * 4)

    // set color
    this.colorIndex = Math.floor(Math.random() * this.options.colors.length)
    if (this.colorIndex === this.options.colors.length) { this.colorIndex-- }
    this.filled = Math.round(Math.random())
  }

  setPoints (screen, reset = false) {
    if (reset) {
      this.randomPos = Math.random()
    }

    switch (this.side) {
      case 0:
      case 2:
        this.origin = {
          x: this.boundaries[this.side],
          y: this.randomPos * (screen.h * 1.2) - screen.h * 0.1
        }
        break
      case 1:
      case 3:
      case 4:
        this.origin = {
          x: this.randomPos * (screen.w * 1.2) - screen.w * 0.1,
          y: this.boundaries[this.side]
        }
        break
    }

    const dist = {
      x: (this.origin.x - screen.w / 2),
      y: (this.origin.y - screen.h / 2)
    }
    const mult = Math.min(screen.w, screen.h) * this.options.fade.end / Math.sqrt(dist.x ** 2 + dist.y ** 2)
    this.endPoint = {
      x: screen.w / 2 + dist.x * mult,
      y: screen.h / 2 + dist.y * mult
    }
  }

  setRandoms (screen, init = false) {
    this.size = this.options.size.min + Math.random() * (this.options.size.max - this.options.size.min)

    this.scaledPoints = this.points.map(point => {
      return [point[0] * this.size, point[1] * this.size]
    })

    if (init) {
      const r = Math.random()
      this.position = {
        x: this.endPoint.x + r * (this.origin.x - this.endPoint.x),
        y: this.endPoint.y + r * (this.origin.y - this.endPoint.y)
      }
    }

    this.speed = this.size * this.options.speed.sizeRatio + Math.random() * this.options.speed.randomRatio

    this.offsetRatio = (this.size - this.options.size.min) / (this.options.size.max - this.options.size.min) * (this.options.offsetSizeRatio.max - this.options.offsetSizeRatio.min) + this.options.offsetSizeRatio.min
  }

  setDirection (screen) {
    const dist = {
      x: (screen.w / 2 - this.position.x),
      y: (screen.h / 2  - this.position.y)
    }
    const max = Math.max(Math.abs(dist.x), Math.abs(dist.y))
    this.direction = {
      x: dist.x / max * this.speed,
      y: dist.y / max * this.speed
    }
  }

  get () {
    return this
  }
}